/**
 * @file
 * Pluxee pager script.
 */

(function (Drupal, $, once) {

  'use strict';

  Drupal.behaviors.pluxeePager = {

    attach: function (context, settings) {
      /**
       * Constants.
       */
      const PAGER_LEFT = 2;
      const PAGER_RIGHT = 2;
      /**
       * Pagerer embedded scrollpane event binding.
       */
      $(once('pager', '.pager', context)).each(function () {
        let $this = $(this);
        const showMoreText = Drupal.t('Show more pages');
        const WRAPPER_DOT = '<li class="pager__item more_pager pager__item--ellipsis" role="presentation"><a href="javascript:void(0)" role="button" aria-label="'+showMoreText+'">…</a></li>';
        const totalPagerToShow = PAGER_LEFT + PAGER_RIGHT + 1;
        const currentPager = $this.find(".pager__items > .pager__item.is-active").index();
        const allActivePagerItems = $this.find(".pager__items .pager__item:not('.pager__item--next, .pager__item--previous')");
        const numberOfItems = allActivePagerItems.length;
        let rightEllipsis = 0;
        let leftEllipsis = 0;
        // Nothing to do if no ellipsis
        if (numberOfItems > totalPagerToShow + 1) {
          leftEllipsis = currentPager - (PAGER_LEFT + 1);
          if (leftEllipsis < 0) {
            rightEllipsis = currentPager + PAGER_RIGHT + Math.abs(leftEllipsis);
            leftEllipsis = 0;
          } else {
            leftEllipsis = currentPager - (PAGER_LEFT + 1);
            rightEllipsis = numberOfItems - (currentPager + PAGER_RIGHT);
            if (rightEllipsis < 0) {
              leftEllipsis = leftEllipsis + rightEllipsis;
              rightEllipsis = numberOfItems;
            } else {
              rightEllipsis = currentPager + PAGER_RIGHT;
            }
          }
          if (leftEllipsis || rightEllipsis) {
            allActivePagerItems.hide().slice(leftEllipsis, rightEllipsis).show();
          }

          if (leftEllipsis - 2 >= 0) {
            allActivePagerItems.first().show();
            allActivePagerItems.first().after(WRAPPER_DOT);
          }

          if (rightEllipsis + 2 <= numberOfItems) {
            allActivePagerItems.last().before(WRAPPER_DOT);
            allActivePagerItems.last().show();
          }
          // Case no ellipsis, and we need to add first and last item.
          if (currentPager === (PAGER_RIGHT + PAGER_RIGHT) && (numberOfItems === (totalPagerToShow + 2))) {
            allActivePagerItems.first().show();
            allActivePagerItems.last().show();
          }
          var previousItem = $this.find(".pager__items .pager__item--previous");
          var nextItem = $this.find(".pager__items .pager__item--next");
          const pagerItems = $this.find(".pager__items");
          const visibleItems = pagerItems.find(".pager__item:not([style='display: none;'])").length;
          if (visibleItems <= 9) {
            pagerItems.css("flex-wrap", "nowrap");
          }
          $this.show();
          let ellipsis = $this.find(".pager__items .more_pager.pager__item--ellipsis");
          $(ellipsis).on("click", function () {
            allActivePagerItems.show();
            previousItem.hide();
            nextItem.hide();
            ellipsis.hide();
            if (pagerItems.find(".pager__item:not([style='display: none;'])").length > 9) {
              pagerItems.css("flex-wrap", "wrap");
            }
          });
        } else {
          $this.show();
        }
      });
    }
  };
})(Drupal, jQuery, once);
